import moment from 'moment'

export default {
  data () {
    return {
      filterQuery: '',
      filterId: '',
      keys: [],
    }
  },
  timer: null,
  methods: {
    setFilterId(id, keys) {
      this.filterId = id;
      this.keys = keys;

      const storedData = localStorage.getItem(this.filterId);
      if (storedData) {
        const data = JSON.parse(storedData);
        const { filter_data, expiration_time } = data;

        if (filter_data) {
          const currentTime = new Date().getTime();
          if (!expiration_time || currentTime <= expiration_time) {
            this.filters = filter_data;
          } else {
            localStorage.removeItem(this.filterId);
          }
        } else {
          localStorage.removeItem(this.filterId);
        }
      }
    }
  },
  watch: {
    'filters': {
      handler (value) {
        clearTimeout(this.timer)
        this.filterQuery = ''
        const queries = []
        for (const filter in value) {
          if (this.filters[filter] && this.filters[filter] !== '') {
            if (this.filters[filter] instanceof Date) {
              queries.push(`filter[${filter}]=${encodeURIComponent(moment(this.filters[filter]).format('YYYY-MM-DD'))}`)
            } else if(this.filters[filter].constructor === Array) {
              queries.push(`filter[${filter}]=${encodeURIComponent(this.filters[filter].toString())}`)
            } else if (typeof this.filters[filter] === 'object') {
              if (this.filters[filter].value)queries.push(`filter[${filter}]=${encodeURIComponent(this.filters[filter].value)}`)
            } else {
              queries.push(`filter[${filter}]=${encodeURIComponent(this.filters[filter])}`)
            }
          }
        }
        if (queries.length > 0) this.filterQuery = queries.join('&')
        const that = this
        if(this.filterId !== '') {
          const filterKeys = Object.keys(this.filters);
          const expiration_time = new Date().getTime() + 5 * 60 * 1000;
          let storeFilter = { expiration_time, filter_data: {  } }
          filterKeys.map(key => {
            if(this.keys.includes(key)){
              storeFilter.filter_data[key] = this.filters[key]
            }
          })
          localStorage.setItem(this.filterId, JSON.stringify(storeFilter))
        }
        this.timer = setTimeout(function () {
          that.filterQueryUpdate()
        }, 1000)
      },
      deep: true,
      immediate: true
    }
  }
}
